import {
  CommentView,
  FileTypeError,
  UploadBox,
  UploadedFile,
} from '@components/SiteUserUpload/Components/Steps/components/UploadFileStep.views';
import { UploadFileTypeEnum } from '@dynamika-shared/types/inventory';
import { FC } from 'react';
import { detectFileExtensions } from '../utils/detectFileExtension';

type FileUploadInitialViewProps = {
  error: boolean;
  file: File | null | undefined;
  setFile: (file: File | null) => void;
  progress: number;
  setAdditionalComment: (comment: string) => void;
  fileType: UploadFileTypeEnum | null;
};

export const FileUploadInitialView: FC<FileUploadInitialViewProps> = ({
  error,
  file,
  setFile,
  progress,
  setAdditionalComment,
  fileType,
}) => {
  const selectedFileType = detectFileExtensions({ fileType });
  return (
    <div className='flex h-full w-full flex-col justify-between'>
      {!file && (
        <div className='flex flex-col items-center justify-center h-full'>
          <div className='mx-auto w-full'>
            <UploadBox
              file={file}
              setFile={setFile}
              progress={progress}
              acceptFile={selectedFileType}
            />
          </div>
        </div>
      )}

      {file && (
        <div className=' flex flex-col items-center justify-center m-auto max-w-[512px] w-full'>
          {error ? (
            <div className='w-full flex flex-col justify-center'>
              <FileTypeError fileType={fileType} />
              <UploadBox
                file={undefined}
                setFile={setFile}
                progress={progress}
                acceptFile={selectedFileType}
              />
            </div>
          ) : (
            <UploadedFile file={file} setFile={setFile} />
          )}
        </div>
      )}
      <CommentView setAdditionalComment={setAdditionalComment} />
    </div>
  );
};
